export const isIOSWebView =
  /(iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent) &&
  !/Safari/i.test(navigator.userAgent);

export const isWebView = localStorage.getItem('@Webview');
